<template>
  <div class="main-template">
    <header class="app-title">
      <Header :uname="uname"></Header>
      <nav class="nav">
        <NavButton
          v-for="(nav,index) in navList"
          :key="index+1"
          :title="nav.title"
          :url="nav.url"
          :icon="nav.icon"
          :isRequired="nav.isRequired"
          :isSelected="nav.isSelected"
        ></NavButton>
      </nav>
    </header>
    <aside class="left-menu">
      <el-menu
        ref="sideMenu"
        router
        default-active="/"
        text-color="#8e9bb4"
        active-text-color="#4c95e9"
        :unique-opened="true"
      >
        <!-- 递归生成左侧菜单栏 -->
        <recursive-menu v-for="submenu in routers" :submenu="submenu" :key="submenu.Id"></recursive-menu>
      </el-menu>
    </aside>
    <main class="main-container">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </main>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import NavButton from "@/components/NavButton.vue";
import { mapState } from "vuex";
import RecursiveMenu from "@/components/RecursiveMenu.vue";
// import USER from "../api/user";

export default {
  name: "Main",
  data() {
    return {};
  },

  components: {
    Header,
    NavButton,
    RecursiveMenu,
  },
  computed: {
    ...mapState("nav", {
      navList: (state) => state.navList,
      currentMenu: (state) => {
        return state.currentNav.url;
      },
    }),
    ...mapState("user", ["routers", "uname"]),
  },
  methods: {
    // getPowerRouter() {
    //   USER.getRouter().then((res) => {
    //     if (res.status === "success") {
    //       this.routers = res.content;
    //     } else {
    //       this.$router.push("/login"); //路由生成失败的话，返回重新登录
    //     }
    //   });
    // },
  },
  created() {
    //获取用户信息
    this.$store.commit("user/SET_USER_INFO");
    //刷新顶部导航
    this.$store.commit("nav/RELOAD_NAV");
    //获取设置线路
    this.$store.dispatch("trip/setRoutes");
    //获取项目
    this.$store.dispatch("trip/setProjects");
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log(to);
  //   console.log(from);
  //   next();
  // },
  watch: {
    currentMenu: function (newMenu) {
      this.$refs["sideMenu"].activeIndex = newMenu;
    },
    $route: function (to, from) {
      if (to.path === from.path) {
        return false;
      }
      if (this.$store.state.nav.navList.length === 0) {
        if (window.sessionStorage.getItem("navList") !== null) {
          let navList = JSON.parse(window.sessionStorage.getItem("navList"));
          this.$store.commit("nav/SET_NAV", navList);
        } else {
          this.$store.dispatch("nav/openView", {
            title: "首页",
            url: "/",
            isRequired: true,
            icon: "fa fa-home",
          });
        }

        return;
      }
      if (to.fullPath === "/") {
        //fullPath改成path  避免重复
        this.$store.dispatch("nav/openView", {
          title: to.name,
          url: to.path,
          isRequired: true,
          icon: "fa fa-home",
        });
      } else {
        this.$store.dispatch("nav/openView", { title: to.name, url: to.path });
      }
    },
  },
};
</script>

<style lang="less">
.main-template {
  height: 100vh;
  overflow: auto;
}
.main-template .nav {
  position: fixed;
  display: flex;
  top: 34px;
  left: 380px;
  min-width: 600px;
  overflow: hidden;
  z-index: 1001;
}
.main-template .left-menu {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 999;
  width: 150px;
  height: 100%;
  background: #efefef;
  border-right: 1px solid #ddd;
  overflow: hidden auto;
}
.main-template .left-menu .el-menu {
  background: #efefef;
  font-size: 12px;
  font-weight: bold;
  color: #909fbc;
}

.main-container {
  padding: 60px 0 0 150px;
  // width: 100%;
  background: #fff;
  min-width: 1360px;
  overflow: hidden;
}
.main-container .manage-query {
  height: 45px;
  padding: 0 20px;
  background: #efefef;
  border-bottom: 1px solid #ddd;
}
.manage-query .query-middle {
  position: relative;
  top: 50%;
  transform: translateY(-30%);
  white-space: nowrap;
}
.main-container .manage-content {
  display: flex;
  border-top: 1px solid #ddd;
  overflow-x: auto;
}
.manage-content .main-title {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 5px 10px;
  align-items: center;
  background: #efefef;
  height: 38px;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  z-index: 9999;
  position: absolute;
}

//滚动条的滑块
::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
}
</style>